module.exports = __webpack_public_path__ + "media/images/pic/blog-15a2ed43919dff0326de3bf87c7dc137.jpeg";